import { Icon } from "@blueprintjs/core"
import React from "react"

import styles from "./DropdownSelector.module.css"

import Dropdown from "~/common/Dropdown/Dropdown"
import MenuItem from "~/common/MenuItem"

export type SelectorOption<T = any> = {
  value: T
  label: string
}

type Props<T> = {
  selectedValue: T
  options: ReadonlyArray<SelectorOption<T>>
  onChange: (option: SelectorOption<T>) => void
  dataTestId?: string
  className?: string
}

const DropdownSelector = <T,>(props: Props<T>) => {
  const { selectedValue, options, onChange, dataTestId, className } = props

  const selectedOption = options.find((o) => o.value === selectedValue)

  return (
    <div data-test={dataTestId}>
      <Dropdown
        Target={() => (
          <div className={styles.label}>
            <span>{selectedOption?.label}</span>
            <Icon icon="chevron-down" size={14} />
          </div>
        )}
        placement="bottom-start"
      >
        <div className={className}>
          {options.map((option) => (
            <MenuItem
              key={String(option.value)}
              text={option.label}
              active={selectedOption?.value === option.value}
              onClick={() => onChange(option)}
            />
          ))}
        </div>
      </Dropdown>
    </div>
  )
}

export default DropdownSelector
